import React from "react";
import { Image, Form, Icon } from "semantic-ui-react";
import personImg from "../../common/person.png";
import { convertToBEDate } from "../../../utils/tsUtils";
import { downloadOrOpenFile, isValidHttpUrl } from "./MyMessage";

import DialogMessage from "./DialogMessage";
import MessageContentHTML from "./MessageContentHTML";
import DisplayContentImage from "./DisplayContentImage";
import DisplayContentFile from "./DisplayContentFile";
import ButtonDownloadFile from "./ButtonDownloadFile";
import ChatVideoContent from "./ChatVideoContent";
import ChatLinkifyMessage, { hasMarkdownPattern } from "./ChatLinkifyMessage";
import moment from "moment";

interface FriendMessageProps {
  avatarBotUrlString?: string;
  isBot?: boolean;
  isMobile?: boolean;
  onOpenVideoCall?: () => void;
  onNavigationMessage?: () => void;
  getLastMessage?: () => void;
  acceptContentHTML?: boolean;
  onClickLink?: () => void;
  icon?: string;
  downloadFile?: boolean;
  showFileSize?: boolean;
  isMediaViewer?: boolean;
  language?: string;
  onLoadImage?: (id: any) => void;
}

const DEFAULT_PROPS = {
  avatarBotUrlString: "",
  isBot: false,
  isMobile: false,
  onOpenVideoCall: ({ url }) => {},
  onNavigationMessage: ({ content = "" }) => content,
  onMobileOpenImage: () => {},
  getLastMessage: () => {},
  acceptContentHTML: false,
  onClickLink: () => {},
  icon: "",
  downloadFile: false,
  language: "th-TH",
};

const FriendMessage = (propsParam: FriendMessageProps) => {
  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value]) => value !== undefined)),
  };

  const dateFormat = "DD/MM/YYYY";
  // console.log(" FriendMessage ", props)
  const createMessage = () => {
    if (props.message.content_type === "file") {
      return (
        <DisplayContentFile
          content={props.message.content}
          file={props.message.content_file}
          isMediaViewer={props.isMediaViewer}
          showFileSize={props.showFileSize}
        />
      );
    } else if (props.message.content_type === "image") {
      return (
        <DisplayContentImage
          id={props.message.id}
          isMediaViewer={props.isMediaViewer}
          isMobile={props.isMobile}
          src={props.message.content_file}
          onLoadImage={props.onLoadImage}
        />
      );
    } else if (props.message.content_type === "video") {
      if (!props.message.content_file) {
        return "Unable to get video";
      }

      return (
        <ChatVideoContent
          file={props.message.content_file}
          isMediaViewer={props.isMediaViewer}
          isMobile={props.isMobile}
        />
      );
    } else if (props.message.content_type === "vid_call") {
      return <Icon name="call square" size="big" color="green" />;
    } else if (props.message.content_type === "end_call") {
      return <Icon name="call square" size="big" color="gray" />;
    } else if (props.message.content_type === "Preverification") {
      return props.onNavigationMessage({
        content: props.message.content,
        contentPayload: { ...props.message.content_payload, send_at: props.message.send_at },
        contentType: props.message.content_type,
        channelId: props.message.channel,
      });
    } else if (props.message.content_type === "navigation") {
      return props.onNavigationMessage({
        content: props.message.content,
        contentPayload: props.message.content_payload,
        channelId: props.message.channel,
      });
    } else if (["bill", "shipping"].includes(props.message.content_type)) {
      return props.onNavigationMessage({
        content: props.message.content,
        contentPayload: props.message.content_payload,
        contentType: props.message.content_type,
        channelId: props.message.channel,
      });
    } else if (
      ["patient_appointment", "patient-appointment-update", "diag_rule"].includes(
        props.message.content_type
      )
    ) {
      return props.onNavigationMessage({
        content: props.message.content,
        contentPayload: props.message.content_payload,
        contentType: props.message.content_type,
        channelId: props.message.channel,
      });
    } else if (props.message.content_type === "dialog_box") {
      return (
        <DialogMessage
          content={props.message.content}
          contentPayload={props.message.content_payload}
          getLastMessage={props.getLastMessage}
        />
      );
    } else if (props.message.content_type === "post") {
      return props.onNavigationMessage({
        content: props.message.content,
        contentPayload: props.message.content_payload,
        contentType: props.message.content_type,
        channelId: props.message.channel,
        author: props.message.author,
        sendAt: props.message.send_at,
        messageId: props.message.id,
        onLoadImage: props.onLoadImage,
      });
    } else if (props.message.content_type === "html") {
      return <MessageContentHTML content={props.message.content} />;
    } else {
      // text_hyper_link is custom type for teleDesktop
      if (
        props.message.content.includes("http") &&
        (props.message.content.includes("/form/") ||
          props.message.content.includes("/assessment-form/")) &&
        (!props.isMobile || hasMarkdownPattern(props.message.content))
      ) {
        return (
          <ChatLinkifyMessage
            content={props.message.content}
            contentPayload={props.message.content_payload}
            isMobile={props.isMobile}
            onNavigationMessage={props.onNavigationMessage}
            onClickLink={props.onClickLink}
          />
        );
      } else if (
        props.acceptContentHTML &&
        props.message.content?.trim().startsWith("<div") &&
        props.message.content?.trim().endsWith("</div>")
      ) {
        // It's bot
        // console.log("props.message.content", props.message.content);
        return (
          <div
            style={{ color: "#4f4f4f" }}
            dangerouslySetInnerHTML={{ __html: props.message.content }}
          />
        );
      } else {
        // Not Bot
        if (props.message.content.includes("http")) {
          return (
            <ChatLinkifyMessage
              content={props.message.content}
              isMobile={props.isMobile}
              isPlainText
            />
          );
        } else {
          return props.message.content;
        }
      }
    }
  };

  return (
    <Form className="FriendMessage">
      {!props.isBot && props.message.author ? (
        props.icon !== "" ? (
          <Form.Field className="friendName_icon">
            <div
              style={{
                background: "#ffffff",
                borderRadius: "20px",
                padding: "5px",
              }}
            >
              <Image
                src={props.icon ? props.icon : personImg}
                style={{ width: "25px", height: "25px" }}
                circular
                // onMouseOver={() => console.log(9999)}
              />
            </div>
            <b style={{ marginLeft: "5px" }}>{props.message.author.full_name}</b>
          </Form.Field>
        ) : (
          <Form.Field className="friendName">
            <b>{props.message.author.full_name}</b>
          </Form.Field>
        )
      ) : null}

      <Form.Group
        inline
        style={{
          alignItems: "flex-start",
          flexWrap: "nowrap",
          flexDirection: "row",
        }}
      >
        {!props.isBot && (
          <Form.Field width={1} className="avatarImage">
            <Image
              src={
                props.message.author && props.message.author.image
                  ? props.message.author.image
                  : personImg
              }
              circular
              size="mini"
              // onMouseOver={() => console.log(9999)}
            />
          </Form.Field>
        )}

        {props.isBot && (
          <Form.Field
            style={{
              maxWidth: "50px",
              minWidth: "50px",
              padding: "0px 4px 0px 0px",
            }}
          >
            <Image src={props.avatarBotUrlString} circular />
          </Form.Field>
        )}

        <Form.Field
          className={"content" + (props.isBot ? " chatbot" : "")}
          {...(props.isMobile &&
            props.message.content_type === "file" && {
              href: props.message.content_file,
            })}
          onClick={() => {
            if (props.message.content_type == "vid_call" && !props.isMobile) {
              props.onOpenVideoCall({ url: props.message.content });
            }
            if (props.message.content_type === "file") {
              downloadOrOpenFile({ downloadFile: props.downloadFile, ...props.message });
            }
            if (props.isMobile && props.message.content_type === "image") {
              props.onMobileOpenImage(props.message.content_file);
            }
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              paddingTop: "0.3rem",
            }}
          >
            <div
              className="bubble"
              style={{
                ...(["patient_appointment"].includes(props.message.content_type || "") && {
                  maxWidth: "80%",
                  overflow: "hidden",
                }),
                maxWidth: "500px",
                wordBreak: "break-word",
              }}
            >
              {createMessage()}
            </div>
            <div className="sendDateTime">
              <div> {props.message.send_at.split(" ")[1]}</div>
              <div>
                {" "}
                {props.language === "th-TH"
                  ? convertToBEDate({
                      date: props.message.send_at.split(" ")[0],
                    })
                  : moment(props.message.send_at.split(" ")[0], dateFormat).format(dateFormat)}{" "}
              </div>
            </div>
          </div>
        </Form.Field>
      </Form.Group>
      <ButtonDownloadFile
        style={{ direction: "ltr", marginTop: "-0.85rem" }}
        content={props.message.content}
        contentFile={props.message.content_file}
        contentType={props.message.content_type}
        showFileSize={props.showFileSize}
      />
    </Form>
  );
};

export default React.memo(FriendMessage);
